import React from 'react';

export const defaultContextValue = { batchLinkTimeout: null, useBatchLink: false };

const ServerContext = React.createContext(defaultContextValue);

export default ServerContext;
